export const AUTH_REDIRECT_PATH_KEY = 'auth_redirect_path'

/** Google OAuth entry point (used in app and static landing HTML). */
export function getSignInHref(from = '/', apiUrl = process.env.REACT_APP_API_URL ?? ''): string {
  return `${apiUrl}/api/auth/google?from=${encodeURIComponent(from)}`
}

/** Microsoft (Azure Entra ID) OAuth entry point. */
export function getMicrosoftSignInHref(from = '/', apiUrl = process.env.REACT_APP_API_URL ?? ''): string {
  return `${apiUrl}/api/auth/microsoft?from=${encodeURIComponent(from)}`
}
